import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isMobile } from "react-device-detect";

const HomeCarousel = () => {
  const autoplay = Autoplay({ delay: 3500, stopOnInteraction: false });

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const [bannerData, setBannerData] = useState([]);
  const getBannerData = async (userId = "") => {
    const { status, data } = await apiPost(apiPath.getBanner, {
      type: "home_top",
      user_id: userId,
    });

    if (status === 200 && data?.success) {
      setBannerData(data?.results?.banners);
    }
  };
  useEffect(() => {
    getBannerData(user?.user?._id || "");
  }, [user]);
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: "center", containScroll: false },
    [],
  );

  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [scrollSnaps, setScrollSnaps] = React.useState([]);

  const onInit = useCallback(
    (api) => {
      setScrollSnaps(api.scrollSnapList());
    },
    [autoplay],
  );

  const onSelect = useCallback((api) => {
    setSelectedIndex(api.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  return (
    <>
      <style>{`
        .hc-wrap { ; padding: 10px 0 8px;background:#085f66 }
        .hc-viewport { overflow: hidden; }
        .hc-container { display: flex; touch-action: pan-y; }
        .hc-slide {
          flex: 0 0 80%;
          min-width: 0;
          padding:0 8px;
          transition: opacity .4s ease, transform .4s ease;
        }
          .hc-slide.is-active{ 
          padding:0;
          }
        .hc-slide img {
          width: 100%; height:${isMobile ? '122px' : '250px'};
          object-fit: cover; border-radius: 5px; display: block;
          transition: opacity .4s ease, transform .4s ease;
        }
        .hc-slide.is-active img { opacity: 1; transform: scale(1); }
        .hc-slide:not(.is-active) img { opacity: 0.5;}
        .hc-dots {
          display: flex; justify-content: center;
          align-items: center; gap: 5px; margin-top: 10px;
        }
        .hc-dot {
          width: 12px; height: 2px; border-radius: 50%;
          background: rgba(255,255,255,0.3);
          border: none; padding: 0; cursor: pointer;
          transition: all 0.3s ease;
        }
        .hc-dot.active {
          width: 22px; height: 2px;
          border-radius: 4px; background: white;
        }
      `}</style>

      <div className="hc-wrap">
        <div className="hc-viewport" ref={emblaRef}>
          <div className="hc-container">
            {bannerData.map((item, i) => (
              <div
                key={i}
                className={`hc-slide${i === selectedIndex ? " is-active" : ""}`}
              >
                <img
                  src={process.env.REACT_APP_API_BASE_URL + item.banner_path}
                  alt={`banner-${i}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="hc-dots">
          {scrollSnaps.map((_, i) => (
            <button
              key={i}
              className={`hc-dot${i === selectedIndex ? " active" : ""}`}
              onClick={() => emblaApi?.scrollTo(i)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default HomeCarousel;
